import { Button, ErrorSummary, Hidden } from '@ahmdigital/ui';
import { connect } from 'react-redux';
import { Form, useFormikContext } from 'formik';
import { isEmpty, pick } from 'lodash/fp';

import { AGE_FIELD_ERROR_MESSAGES } from '../../../../pages/home/data/constants';
import { FieldNames, Match } from '../../types';
import { Location } from '../../../../types/location';
import { ProductType } from '../../../../types/product';
import AgeField from './components/age-field';
import ExcessToggle from './components/excess-toggle';
import IncomeTierField from './components/income-tier-field';
import IncomeTypeField from './components/income-type-field';
import PaymentFrequencyField from './components/payment-frequency-field';
import ScaleField from './components/scale-field';
import selectExcessToggleValues, { ExcessToggleValues } from '../../../../selectors/select-excess-toggle-values';
import selectIsExcessToggleApplicable, {
  IsExcessToggleApplicableType,
} from '../../../../selectors/select-is-excess-toggle-applicable';
import StateField from './components/state-field';

const schemaForErrorSummary = {
  age: {
    linkPhrases: ['age'],
  },
  frequency: {
    linkPhrases: ['payment frequency'],
  },
  incomeTier: {
    linkPhrases: ['annual income'],
  },
  partnerAge: {
    linkPhrases: ['partner’s age'],
  },
  scale: {
    linkPhrases: ['cover type'],
  },
  state: {
    linkPhrases: ['state'],
  },
};

const errorOrder = ['scale', 'state', 'frequency', 'age', 'partnerAge', 'incomeTier'];

type CustomerFormProps = {
  hasSubmitAttempt?: boolean;
  hospitalExcess: ExcessToggleValues;
  isExcessApplicable: IsExcessToggleApplicableType;
  isProductWithHospitalServices: boolean;
  location?: Location;
  match?: Match;
  product?: ProductType;
  showIncomeOptions?: boolean;
};

const CustomerForm = ({
  hasSubmitAttempt,
  hospitalExcess,
  isExcessApplicable,
  isProductWithHospitalServices,
  location,
  match,
  product,
  showIncomeOptions = true,
}: CustomerFormProps) => {
  const { errors, handleSubmit, touched } = useFormikContext<Partial<Record<FieldNames, string>>>();

  // Show only the generic error message for age and partnerAge in the error summary alert. The specific error messages will be shown below the fields.
  const ageErrorMessageForSummary = errors.age ? { age: AGE_FIELD_ERROR_MESSAGES.AGE } : {};
  const partnerAgeErrorMessageForSummary = errors.partnerAge
    ? { partnerAge: AGE_FIELD_ERROR_MESSAGES.PARTNER_AGE }
    : {};
  const errorsForSummary = { ...errors, ...ageErrorMessageForSummary, ...partnerAgeErrorMessageForSummary };

  return (
    <>
      {hasSubmitAttempt && !isEmpty(errors) && (
        <ErrorSummary errors={pick(errorOrder, errorsForSummary)} schema={schemaForErrorSummary} touched={touched} />
      )}
      {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ children: (false | Element)[]; onSubmit: (e?: FormEvent<HTMLFormElement> | undefined) => void; }' is missing the following properties from type 'Pick<DetailedHTMLProps<FormHTMLAttributes<HTMLFormElement>, HTMLFormElement>, "method" | "about" | ... 260 more ... | "onPointerLeaveCapture">': placeholder, onPointerEnterCapture, onPointerLeaveCapture */}
      <Form onSubmit={handleSubmit}>
        <ScaleField product={product} />
        <StateField />
        {/* @ts-expect-error - Automatic, Please fix when editing this file */}
        <PaymentFrequencyField location={location} />
        {/* @ts-expect-error - Automatic, Please fix when editing this file */}
        <AgeField hasSubmitAttempt={hasSubmitAttempt} isProductWithHospitalServices={isProductWithHospitalServices} />
        <ExcessToggle hospitalExcess={hospitalExcess} isExcessApplicable={isExcessApplicable} match={match} />
        {showIncomeOptions && <IncomeTypeField />}
        {showIncomeOptions && <IncomeTierField />}
        {/* Hidden button to allow Enter key to submit form */}
        <Hidden md sm xs df lg>
          {/* @ts-expect-error [🤖 PLEASE FIX 🤖]: Type '{ children: string; type: string; onClick: (e?: FormEvent<HTMLFormElement> | undefined) => void; }' is not assignable to type 'IntrinsicAttributes & Pick<Pick<ButtonProps, keyof ButtonProps> & Pick<InferProps<{ variant: Requireable<NonNullable<string | object | null | undefined>>; analytics: Requireable<...>; }>, "analytics"> & Pick<...>, "icon" | "analytics"> & Partial<...> & Partial<...>'. */}
          <Button type="submit" onClick={handleSubmit}>
            Update
          </Button>
        </Hidden>
      </Form>
    </>
  );
};

// @ts-expect-error - Automatic, Please fix when editing this file
const mapStateToProps = (state, props) => ({
  hospitalExcess: selectExcessToggleValues(state),
  isExcessApplicable: selectIsExcessToggleApplicable(state, props),
  location: state?.router?.location,
  products: state.product.data,
});

export default connect(mapStateToProps)(CustomerForm);
